import { ModelGroup, StringField } from '@mng/model';

export function createGvErlaubteGeschaeftsfaelleModelGroup(id = 'erlaubteGeschaeftsfaelle'): ModelGroup {
  const geschaeftsfallModelGroup: ModelGroup = new ModelGroup(id, 'erlaubte Geschäftsfälle').withInterfaceName(
    'GvGeschaeftsfall'
  );
  geschaeftsfallModelGroup.addItems(
    new StringField('id').withReadOnly(),
    new StringField('name').withReadOnly(),
    new StringField('ebene').withReadOnly()
  );

  return geschaeftsfallModelGroup;
}

export function createGvBestandErlaubteGeschaeftsfaelleModelGroup(id = 'bestandErlaubteGeschaeftsfaelle'): ModelGroup {
  const geschaeftsfallModelGroup: ModelGroup = new ModelGroup(id, 'bestand erlaubte Geschäftsfälle').withInterfaceName(
    'GvGeschaeftsfall'
  );
  geschaeftsfallModelGroup.addItems(
    new StringField('id').withReadOnly(),
    new StringField('name').withReadOnly(),
    new StringField('ebene').withReadOnly()
  );

  return geschaeftsfallModelGroup;
}

export function createGvAusgefuehrteGeschaeftsfaelleModelGroup(id = 'ausgefuehrteGeschaeftsfaelle'): ModelGroup {
  const geschaeftsfallModelGroup: ModelGroup = new ModelGroup(id, 'ausgeführte Geschäftsfälle').withInterfaceName(
    'GvGeschaeftsfall'
  );
  geschaeftsfallModelGroup.addItems(
    new StringField('id').withReadOnly(),
    new StringField('name').withReadOnly(),
    new StringField('ebene').withReadOnly()
  );

  return geschaeftsfallModelGroup;
}
